import React from "react";
import LibraryComponent from "../LibraryComponent/LibraryComponent";

export default function SuggestedExercise({suggested_exercises, isMerging = false, update = (val) => {}, fromStyles = false, liveEdit = false}) {

    return <LibraryComponent
        uniqueId={suggested_exercises.pattern_suggested_exercises_id} // this is kinda weird cause it is not unique but I need it for update field
        name={suggested_exercises.exercise_name}
        startDesc={suggested_exercises.suggested_exercise_description}
        infoContent={{title: suggested_exercises.pattern_exercise_name, text: suggested_exercises.exercise_description}}
        update={update}
        isMerging={isMerging}
        fromStyles={fromStyles}
        liveEdit={liveEdit}
    />
}